<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper" style="align-items: center; color: #1f1f1f; display: flex; background: #fff;">
    <div class="error-box">
      <h1><i class="fas fa-exclamation-triangle" style="color: sandybrown"></i></h1>
      <p class="h4 font-weight-normal">Not Found!</p>
      <p class="font-weight-normal">The page you are looking for does not exist or was moved.</p>
      <router-link to="/" class="btn btn-success">
        <i class="fas fa-backward"></i> Go Back Home
      </router-link>
    </div>
  </div>
  <!-- /Main Wrapper -->
</template>

<script>
export default {
  name: 'Error404'
}
</script>

<style scoped>
.error-box {
  text-align: center;
  margin: 0 auto;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Error404.vue